import React, { useState } from 'react'
import { Box, FormHelperText, TextField } from '@mui/material'

import { isValidEmail } from '~utils/emailUtils'

interface EmailEntryBoxProps {
  inputEmailAddress: string
  onChange: (newEmail: string, newIsValid: boolean) => void
}

const EmailEntryBox: React.FC<EmailEntryBoxProps> = ({ inputEmailAddress, onChange }) => {
  const [emailAddress, setEmailAddress] = useState<string>(inputEmailAddress)
  const [blurred, setBlurred] = useState(false)

  const isValid = isValidEmail(emailAddress)
  const showError = blurred && !isValid && emailAddress.length > 0

  const handleEmailAddressChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newEmailAddress = event.target.value
    setEmailAddress(newEmailAddress)
    onChange(newEmailAddress, isValidEmail(newEmailAddress))
  }

  const handleBlur = (): void => {
    setBlurred(true)
  }

  const handleFocus = (): void => {
    setBlurred(false)
  }

  return (
    <Box display='flex' flexDirection='column'>
      <TextField
        value={inputEmailAddress}
        type='email'
        onBlur={handleBlur}
        onFocus={handleFocus}
        onChange={handleEmailAddressChange}
        error={showError}
      />
      {showError && (
        <FormHelperText error sx={{ ml: 2, mt: 0.5 }}>
          Please enter a valid email address
        </FormHelperText>
      )}
    </Box>
  )
}

export default EmailEntryBox
